export var EMode;
(function (EMode) {
    EMode["ITEM"] = "item";
    EMode["BAND"] = "band";
})(EMode || (EMode = {}));
//# sourceMappingURL=interfaces.js.map